var _circle, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 21.25,
    stroke: "#26CD9F",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8579 22.7331C18.6309 22.214 19.1643 21.1868 19.1643 20.263C19.1643 18.9594 18.1082 17.9006 16.8035 17.9006C15.4998 17.9006 14.4424 18.9594 14.4424 20.263C14.4424 21.1868 14.9752 22.214 15.746 22.7331C13.9 23.202 12.5283 24.8108 12.5283 25.9994C12.5283 26.7028 14.6662 27.0547 16.8035 27.0547L15.6047 25.8582L16.5141 23.6591H17.0936L18.0041 25.8582L16.8045 27.0547C18.9421 27.0542 21.0789 26.7025 21.0789 25.9994C21.0789 24.8098 19.7083 23.2017 17.8579 22.7331ZM17.0046 23.4195H16.9947L16.9985 23.4285H16.6095L16.6133 23.4195H16.6032L16.2124 22.9697C16.4029 23.0375 16.5977 23.0799 16.8045 23.0799C17.0108 23.0799 17.2057 23.0397 17.3964 22.9717L17.0046 23.4195Z",
    fill: "#26CD9F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7924 20.5515H22.1719C21.9175 20.5515 21.7109 20.3452 21.7109 20.0908C21.7109 19.8365 21.9172 19.6299 22.1719 19.6299H30.7924C31.0465 19.6299 31.2531 19.8365 31.2531 20.0908C31.2528 20.3452 31.0462 20.5515 30.7924 20.5515Z",
    fill: "#26CD9F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7924 22.5516H22.1719C21.9175 22.5516 21.7109 22.3454 21.7109 22.0907C21.7109 21.836 21.9172 21.63 22.1719 21.63H30.7924C31.0465 21.63 31.2531 21.836 31.2531 22.0907C31.2531 22.3454 31.0462 22.5516 30.7924 22.5516Z",
    fill: "#26CD9F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7924 24.5518H22.1719C21.9175 24.5518 21.7109 24.3452 21.7109 24.0906C21.7109 23.8362 21.9172 23.6299 22.1719 23.6299H30.7924C31.0465 23.6299 31.2531 23.8362 31.2531 24.0906C31.2528 24.3452 31.0462 24.5518 30.7924 24.5518Z",
    fill: "#26CD9F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0184 15.5384H31.7378C32.2815 15.5384 32.7242 15.9811 32.7242 16.5248V28.4305C32.7242 28.9745 32.2815 29.4169 31.7378 29.4169H12.2619C11.7182 29.4169 11.2758 28.9745 11.2758 28.4305V16.5248C11.2758 15.9811 11.7182 15.5384 12.2619 15.5384H19.437V13.9553H12.2619C10.8452 13.9553 9.69238 15.1081 9.69238 16.5248V28.4305C9.69238 29.8475 10.8452 31.0001 12.2619 31.0001H31.738C33.1551 31.0001 34.3076 29.8472 34.3076 28.4305V16.5248C34.3076 15.1081 33.1548 13.9553 31.738 13.9553H23.987V15.5384H28.0184Z",
    fill: "#26CD9F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4975 12.2415H19.9268V16.6188H23.4975V12.2415Z",
    fill: "#26CD9F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/info-icon.85e0945ddbce76ef56d44288bc45eeef.svg";
export { ForwardRef as ReactComponent };